const POAFENumber = {
  name: 'POAFENumber',
  title: 'PO/AFE #',
  required: false,
  type: 'text',
  value: '',
  char: 100,
  isIncluded: false,
};
const ProjectNumber = {
  name: 'ProjectNumber',
  title: 'Project #',
  required: false,
  type: 'text',
  value: '',
  char: 100,
  isIncluded: false,
};
const SiteLocation = {
  name: 'SiteLocation',
  title: 'Site Location',
  required: false,
  type: 'text',
  value: '',
  char: 100,
  isIncluded: false,
};
const SiteNumber = {
  name: 'SiteNumber',
  title: 'Site #',
  required: false,
  type: 'text',
  value: '',
  char: 100,
  isIncluded: false,
};
const TaskOrder = {
  name: 'TaskOrder',
  title: 'Task Order',
  required: false,
  type: 'text',
  value: '',
  char: 100,
  isIncluded: false,
};
const LineItem = {
  name: 'LineItem',
  title: 'Line Item',
  required: false,
  type: 'text',
  value: '',
  char: 100,
  isIncluded: false,
};
const CostObject = {
  name: 'CostObject',
  title: 'Cost Object',
  required: false,
  type: 'text',
  value: '',
  char: 100,
  isIncluded: false,
};
const ShelfLife = {
  name: 'ShelfLife',
  title: 'ShelfLife',
  required: true,
  type: 'list',
  value: '',
  isIncluded: false,
};
const RecordOfSiteCondition = {
  name: 'RecordOfSiteCondition',
  title: 'Record of Site Condition',
  type: 'bool',
  required: false,
  value: false,
  isIncluded: false,
};
const AuditSamples = {
  name: 'AuditSamples',
  title: 'Audit Samples',
  type: 'bool',
  required: false,
  value: false,
  isIncluded: false,
};
const DataPackage = {
  name: 'DataPackage',
  title: 'Data Package',
  type: 'bool',
  required: false,
  value: false,
  isIncluded: false,
};
const RequestedBy = {
  name: 'RequestedBy',
  title: 'Requested By',
  required: true,
  type: 'text',
  value: '',
  char: 100,
  isIncluded: true,
};
const RequestedDate = {
  name: 'RequestedDate',
  title: 'Requested Date',
  required: true,
  type: 'date',
  value: '',
  isIncluded: true,
};
export const projectInfoFields = {
  POAFENumber,
  ProjectNumber,
  SiteLocation,
  SiteNumber,
  TaskOrder,
  LineItem,
  CostObject,
  ShelfLife,
  RecordOfSiteCondition,
  AuditSamples,
  DataPackage,
  RequestedBy,
  RequestedDate,
};

export const fieldBundle = {
  0: [],
  1: [ // ENV-GEN
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
    'TaskOrder',
    'LineItem',
    'CostObject',
    'RecordOfSiteCondition',
    ],
  23: [ // ENV-BULK
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
    'TaskOrder',
    'LineItem',
    'CostObject',
    'RecordOfSiteCondition',
  ],
  5: [ // FOOD-GEN
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
  ],
  7: [ // FOOD-NL
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
  ],
  8: [ // FOOD-NHP
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
  ],
  6: [ // FOOD-SL
    'POAFENumber',
    'SiteLocation',
    'SiteNumber',
    'ShelfLife',
  ],
  3: [ // DW-ON
    'POAFENumber',
    'ProjectNumber',
    'SiteNumber',
  ],
  4: [ // DW-NS
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
  ],
  9: [ // DW-BC
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
  ],
  10: [ // DW-MB
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
  ],
  11: [ // DW-QC
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
  ],
  12: [ // DW-RAD
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
    'TaskOrder',
    'LineItem',
    'CostObject',
  ],
  18: [ // IH
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
  ],
  19: [ // IH-CHEMO
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
  ],
  21: [ // IH-OPI
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
  ],
  13: [ // AIR-AMBIENT
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
    'TaskOrder',
    'LineItem',
    'CostObject',
  ],
  15: [ // AIR-SUMMA
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
    'TaskOrder',
    'LineItem',
    'CostObject',
  ],
  14: [ // AIR-SOURCE
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
    'TaskOrder',
    'LineItem',
    'CostObject',
    'AuditSamples',
    'DataPackage',
  ],
  16: [ // AIR-PASSIVE
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
    'TaskOrder',
    'LineItem',
    'CostObject',
  ],
  17: [ // AIR-CGB
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
    'TaskOrder',
    'LineItem',
    'CostObject',
  ],
  20: [ // ASBESTOS
    'POAFENumber',
    'ProjectNumber',
    'SiteLocation',
    'SiteNumber',
    'TaskOrder',
    'LineItem',
    'CostObject',
  ],
};

export const SUBMISSION_TYPES = {
  ENV_GEN: 1,
  ENV_BULK: 23,
  FOOD_GEN: 5,
  FOOD_NL: 7,
  FOOD_NHP: 8,
  FOOD_SL: 6,
  DW_ON: 3,
  DW_NS: 4,
  DW_BC: 9,
  DW_MB: 10,
  DW_QC: 11,
  DW_RAD: 12,
  IH: 18,
  IH_CHEMO: 19,
  IH_OPI: 21,
  AIR_AMBIENT: 13,
  AIR_SUMMA: 15,
  AIR_SOURCE: 14,
  AIR_PASSIVE: 16,
  AIR_CGB: 17,
  ASBESTOS: 20,
};

export default { };



// WEBPACK FOOTER //
// ./src/constants/submissionTypes.js